import type { TFunction } from 'i18next';
import { formatLocalizedDate, formatLocalizedDateTime } from '@/lib/format';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';

const FIRST_WORD_CHARACTER_REGEX = /^\w/;

export function getActorLabel(
  activity: PurchaseOrderActivityItem,
  t: TFunction<'purchaseOrder'>,
) {
  if (activity.actorType === 'system') {
    return t('activity.actors.system');
  }

  if (activity.actorIdentifier) {
    return activity.actorIdentifier;
  }

  return activity.actorType === 'external_user'
    ? t('activity.actors.external')
    : t('activity.actors.internal');
}

export function formatActivityEventCode(eventCode: string) {
  return eventCode
    .replaceAll('_', ' ')
    .replace(FIRST_WORD_CHARACTER_REGEX, (letter) => letter.toUpperCase());
}

export function getKeyDateTypeFromEventCode(
  eventCode: string,
  t: TFunction<'purchaseOrder'>,
): string {
  switch (eventCode) {
    case 'purchase_order_lis_date_updated':
      return t('orderDateLis');
    case 'purchase_order_eta_date_updated':
      return t('orderDateEta');
    case 'purchase_order_eop_date_updated':
      return t('orderDateEop');
    case 'purchase_order_etd_date_updated':
      return t('orderDateEtd');
    default:
      return '';
  }
}

export { formatLocalizedDate, formatLocalizedDateTime };

export function formatKeyDateValues(
  activity: PurchaseOrderActivityItem,
  locale: string,
) {
  const oldValue = formatLocalizedDate(activity.oldValue, locale);
  const newValue = formatLocalizedDate(activity.newValue, locale);
  const hasOldValue = Boolean(oldValue);
  const hasNewValue = Boolean(newValue);
  const isDeletedValue = hasOldValue && !hasNewValue;

  return { oldValue, newValue, hasOldValue, hasNewValue, isDeletedValue };
}
